import { useState } from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQ } from "@/seo/site";

type FaqB2BProps = {
  onCotizar: () => void;
};

export const FaqB2B = ({ onCotizar }: FaqB2BProps) => {
  const [openItem, setOpenItem] = useState<string>();

  if (FAQ.length === 0) {
    return null;
  }

  return (
    <section className="py-20 md:py-24 bg-white">
      <div className="container mx-auto px-6 sm:px-8 md:px-12 lg:px-16">
        <div className="text-center mb-14 md:mb-16">
          <span className="text-primary-dark font-medium tracking-widest uppercase text-sm">
            Preguntas frecuentes
          </span>
          <h2 className="font-playfair font-semibold text-3xl sm:text-4xl md:text-5xl mt-3 text-brown">
            Dudas de tu pedido con tu marca
          </h2>
          <div className="w-24 h-1 bg-primary mx-auto mt-4 rounded-full"></div>
        </div>

        <div className="max-w-3xl mx-auto">
          <Accordion
            type="single"
            collapsible
            value={openItem}
            onValueChange={setOpenItem}
            className="w-full"
          >
            {FAQ.map((item, index) => {
              const value = `faq-${index}`;
              return (
                <AccordionItem key={item.q} value={value}>
                  <AccordionTrigger className="text-left font-playfair text-base md:text-lg text-brown-dark">
                    {item.q}
                  </AccordionTrigger>
                  {/* forceMount mantiene la respuesta en el HTML; `hidden` la
                      colapsa, porque con forceMount Radix no la oculta solo. */}
                  <AccordionContent
                    forceMount
                    hidden={openItem !== value}
                    className="text-brown-light/90 leading-relaxed"
                  >
                    {item.a}
                    {item.pending && (
                      <span className="mt-2 block text-xs font-medium text-primary-dark">
                        Respuesta en confirmación
                      </span>
                    )}
                  </AccordionContent>
                </AccordionItem>
              );
            })}
          </Accordion>
        </div>

        <div className="text-center mt-12">
          <Button
            onClick={onCotizar}
            className="bg-primary text-brown-dark hover:bg-primary-dark font-semibold rounded-full px-8 py-3 shadow-md"
          >
            Cotizar mi pedido
            <ArrowRight className="h-4 w-4 ml-2" />
          </Button>
        </div>
      </div>
    </section>
  );
};
